module.exports = __webpack_public_path__ + "media/images/emblems/Marchissy-coat_of_arms-503855a5f1db6ac09eeec5696ae48f93.svg";